import Helpers from "@/helpers/Helpers";

import siteRoutes from "./siteRoutes";
import gpsGeofenceRoutes from "./gpsGeofenceRoutes";
import buildingRoutes from "./buildingRoutes";

export default [
  ...buildingRoutes,
  ...siteRoutes,
  ...gpsGeofenceRoutes,
  // CONTENT LIST
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId?/levels/:levelId?/map-content",
    name: "MapContent",
    component: Helpers.lazyLoad("MapContentView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/map-content/add",
    name: "MapContentAdd",
    component: Helpers.lazyLoad("MapContentAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/map-content/:featureId/edit",
    name: "MapContentEdit",
    component: Helpers.lazyLoad("MapContentAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/map-content/multiple-add",
    name: "MapContentMultipleAdd",
    component: Helpers.lazyLoad("MapContentMultipleAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/map-content/multiple-edit",
    name: "MapContentMultipleEdit",
    component: Helpers.lazyLoad("MapContentMultipleAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId?/levels/:levelId?/geofences",
    name: "Geofences",
    component: Helpers.lazyLoad("GeofencesView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/beacon-geofences/:featureId/edit",
    name: "BeaconGeofenceEdit",
    component: Helpers.lazyLoad("BeaconGeofenceAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/beacon-geofences/:featureId(add)",
    name: "BeaconGeofenceAdd",
    component: Helpers.lazyLoad("BeaconGeofenceAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId?/levels/:levelId?/wayfinding",
    name: "Wayfinding",
    component: Helpers.lazyLoad("WayfindingView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId?/levels/:levelId?/beacons",
    name: "Beacons",
    component: Helpers.lazyLoad("BeaconsView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/beacons/:featureId",
    name: "BeaconEdit",
    component: Helpers.lazyLoad("BeaconAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/beacons/:featureId(add)",
    name: "BeaconAdd",
    component: Helpers.lazyLoad("BeaconAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/wayfinding-network/path/add",
    name: "PathAdd",
    component: Helpers.lazyLoad("PathAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/wayfinding-network/path/:groupId/edit",
    name: "PathEdit",
    component: Helpers.lazyLoad("PathAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/wayfinding-network/outdoor-path/add",
    name: "OutdoorPathAdd",
    component: Helpers.lazyLoad("OutdoorPathAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/wayfinding-network/outdoor-path/:groupId/edit",
    name: "OutdoorPathEdit",
    component: Helpers.lazyLoad("OutdoorPathAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/transitions/add",
    name: "TransitionAdd",
    component: Helpers.lazyLoad("TransitionAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/buildings/:buildingId/levels/:levelId/transitions/:featureId/edit",
    name: "TransitionEdit",
    component: Helpers.lazyLoad("TransitionAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/transitions/add",
    name: "OutdoorTransitionAdd",
    component: Helpers.lazyLoad("OutdoorTransitionAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  },
  {
    path: "clients/:clientId/sites/:siteId/transitions/:featureId/edit",
    name: "OutdoorTransitionEdit",
    component: Helpers.lazyLoad("OutdoorTransitionAddEditView", "views/content/mapDesigner"),
    meta: { requiresAuth: true }
  }
];
